import { call, put, select, takeLatest } from "redux-saga/effects";
import { getCheckGroupFailure, getExternalPhysiciansRequest, getExternalPhysiciansSuccess, getInternalPhysiciansRequest, getInternalPhysiciansSuccess, GET_EXTERNAL_PHYSICIANS_REQUEST, GET_INTERNAL_PHYSICIANS_FAILURE, GET_INTERNAL_PHYSICIANS_REQUEST, patchAffiliatedGroupRequest, PATCH_AFFILIATED_GROUP_FAILURE, PATCH_AFFILIATED_GROUP_REQUEST, POST_PHYSICIANS_REQUEST } from "../actions/physicianAction";
import { getCheckGroupAPICall, getExternalPhysiciansCall, getInternalPhysiciansCall, getSingleGroupAPICall, patchAffiliatedGroupAPICall, patchUserProfileApiCall, postCreateGroupAPICall, postCreatePhysiciansCall } from "../apis/physicianCallApi";
import { checkAuthorizationError, clearNotification, dataLoadingNotification, errorNotification, successNotification } from "../utils/notification-helpers";
import AuthService from "../services/AuthService";
import { getExternalPhysicians } from "./saga-helpers";



function * getInternalPhysiciansHandler () {
  try {
    const auth = new AuthService()
    const { userSettings } = auth.getProfile() || {}
    const { affiliatedGroup } = userSettings || {}
    if (affiliatedGroup && affiliatedGroup !== "") {
      const { responseStatus, responseJSON } = yield call(getCheckGroupAPICall)
      if (responseStatus >= 200 && responseStatus < 300) {
        const { group_id: groupId } = responseJSON;
        const { responseStatus: physicianResponseStatus, responseJSON: physicianResponseJSON } = yield call(getInternalPhysiciansCall, groupId)
        if(physicianResponseStatus >= 200 && physicianResponseStatus < 300){
          const physicians = physicianResponseJSON && physicianResponseJSON.physicians
          yield put(getInternalPhysiciansSuccess(physicians))
        }
        else if(responseStatus === 401){
          throw Error(responseStatus);
        }
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_INTERNAL_PHYSICIANS_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * postPhysiciansHandler ({ payload }) {
  try {
    const { afterSuccess, name, email, phone_number, affiliatedGroupOfLoggedInUser, affiliated_group, primary_facility, specialty } = payload;
    const { responseStatus, responseJSON: groupResponseJSON } = yield call(getSingleGroupAPICall, name)
    let groupGuid = null;
    const internalPhysician = yield select((state) => state.internalPhysician);
    const externalPhysician = yield select((state) => state.externalPhyscian)

    if (responseStatus >= 200 && responseStatus < 300) {
      if (groupResponseJSON && groupResponseJSON?.length > 0) {
        const findPhysician = externalPhysician.find(item => item?.full_name === name) || internalPhysician.find(item => item?.full_name === name)
        if(findPhysician){
          afterSuccess(findPhysician?.guid)
        } else {
          afterSuccess("true")
          errorNotification('The physician is already exists.')
        }
      } else {
        dataLoadingNotification('')
        if (!affiliated_group) {
          const {
            responseStatus: createGroupResponseStatus,
            responseJSON: createGroupResponse
          } = yield call(postCreateGroupAPICall, {
            name,
            affiliatedGroupOfLoggedInUser
          })
          if (createGroupResponseStatus >= 200 && createGroupResponseStatus < 300) {
            const { group_id: sourceGroupGuid } = createGroupResponse
            groupGuid = sourceGroupGuid
          }
          else if(responseStatus === 401){
            yield put(getCheckGroupFailure());
            throw Error(responseStatus);
          }
          else if(responseStatus === 401){
            throw Error(responseStatus);
          }
        } else {
          groupGuid = affiliatedGroupOfLoggedInUser
        }
      }

      if (groupGuid) {
        const { responseStatus: affiliatedGroupStatus, responseJSON: affiliatedGroup } = yield call(getCheckGroupAPICall)
        if (affiliatedGroupStatus >= 200 && affiliatedGroupStatus < 300) {
          const { group_id: sourceGroupGuid, name: sourceGroupName } = affiliatedGroup
          const { responseStatus: createPhysicianStatus, responseJSON } = yield call(postCreatePhysiciansCall, { name, email: email !== "" ? email : undefined, phone_number, organizationGuid: groupGuid, specialty, primary_facility, invitedByOrganization: { name: sourceGroupName, guid: sourceGroupGuid } })
          if (createPhysicianStatus >= 200 && createPhysicianStatus < 300) {
            const { guid } = responseJSON
            if (!affiliated_group) {
              yield put(patchAffiliatedGroupRequest({ affiliatedGroupGuid: affiliatedGroupOfLoggedInUser, sourceGroupGuid: groupGuid, isPhysician: true }))
              yield put(getExternalPhysiciansSuccess([...externalPhysician, responseJSON]))
            } else {
              yield put(getInternalPhysiciansSuccess([...internalPhysician, responseJSON]))
              // yield put(getInternalPhysiciansRequest())
            }
  
            if (afterSuccess) afterSuccess(guid)
            clearNotification()
          } else if (createPhysicianStatus === 409) {
            const { physician_guid: physicianGuid } = responseJSON
            if (!affiliated_group) {
              let getExternalPhysiciansData = yield select(getExternalPhysicians)
              let getPhysician = getExternalPhysiciansData?.length ? getExternalPhysiciansData.find(physician => physician.guid === physicianGuid) : {}
              const { guid } = getPhysician || {}
              if (guid) {
                if (afterSuccess) afterSuccess(guid)
                clearNotification()
              } else {
                yield put(patchAffiliatedGroupRequest({ affiliatedGroupGuid: affiliatedGroupOfLoggedInUser, sourceGroupGuid: groupGuid, isPhysician: true }))
                yield put(getExternalPhysiciansRequest())
  
              }
            } else {
              if (afterSuccess) afterSuccess(physicianGuid)
              clearNotification()
            }
          }
        }
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_INTERNAL_PHYSICIANS_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * affiliatedGroupHandler ({ payload }) {
  try {
    // dataLoadingNotification('Setting current organization as provider to new Facility')
    if(!payload.affiliatedGroupGuid){
      const auth = new AuthService()
      const userProfile = auth.getUserProfile()
      const requestBody = {app_metadata: {...auth.getProfileRequestBodyForUpdate().app_metadata}}
      requestBody.app_metadata.affiliated_group = payload.sourceGroupGuid
      requestBody.app_metadata.approved_facilities= [payload.sourceGroupGuid]
      const userId = userProfile && userProfile.sub

      const { responseStatus, responseJSON } = yield call(patchUserProfileApiCall, userId, requestBody);
      if(responseStatus >= 200 && responseStatus < 300){
        auth.updateUserAppMetadataInLocalStorage(responseJSON.app_metadata)
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }else {
        console.error('Unable to save profile changes. Please try again.')
      }
    }
    const { responseStatus  } = yield call(patchAffiliatedGroupAPICall, payload)
    if(responseStatus >= 200 && responseStatus < 300){
      clearNotification()
      if (payload?.isPhysician) {
        successNotification(('New Physcian Added'))
      } else {
        successNotification(('New Facility Added'))
      }
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    } else {
      clearNotification()
      if (payload?.isPhysician) {
        console.error('Unable to set the current Organization as Provider to the new Physician')
        errorNotification(('Unable to set the current Organization as Provider to the new Physician'))
      } else {
        console.error('Unable to set the current Organization as Provider to the new Facility')
        errorNotification(('Unable to set the current Organization as Provider to the new Facility'))
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: PATCH_AFFILIATED_GROUP_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}



function * getExternalPhysiciansHandler () {
  try {
    const auth = new AuthService()
    const { userSettings } = auth.getProfile() || {}
    const { affiliatedGroup } = userSettings || {}
    if (affiliatedGroup && affiliatedGroup !== "") {
      const { responseStatus, responseJSON } = yield call(getCheckGroupAPICall)
      if (responseStatus >= 200 && responseStatus < 300) {
        const { group_id: groupId } = responseJSON;
        const { responseStatus: physicianResponseStatus, responseJSON: physicianResponseJSON } = yield call(getExternalPhysiciansCall, groupId)
        if(physicianResponseStatus >= 200 && physicianResponseStatus < 300){
          const physicians = physicianResponseJSON && physicianResponseJSON.physicians
          yield put(getExternalPhysiciansSuccess(physicians))
        }
        else if(responseStatus === 401){
          throw Error(responseStatus);
        }
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_INTERNAL_PHYSICIANS_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

export function * physicianSaga () {
  yield takeLatest(GET_INTERNAL_PHYSICIANS_REQUEST, getInternalPhysiciansHandler)
  yield takeLatest(POST_PHYSICIANS_REQUEST, postPhysiciansHandler)
  yield takeLatest(PATCH_AFFILIATED_GROUP_REQUEST, affiliatedGroupHandler)
  yield takeLatest(GET_EXTERNAL_PHYSICIANS_REQUEST, getExternalPhysiciansHandler)
}
  